"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
exports.OsmosysSidebarPortal = (props) => {
    return react_2.default.createElement(react_1.Portal, Object.assign({ elementID: "app-side-bar" }, props));
};
//# sourceMappingURL=OsmosysSidebarPortal.js.map